import {
    ApiGnomeSnapshotResSchema,
    type ApiGnomeErrorCode,
} from "@bridge-applications/pb-types";
import { authenticatedApiCall } from "./api";
import { createGnomeSnapshotReader } from "./gnomeSnapshotReader";

export class GnomeApiError extends Error {
    readonly code: ApiGnomeErrorCode;
    constructor(code: ApiGnomeErrorCode, message?: string) {
        super(message ?? code);
        this.code = code;
    }
}

export const gnomeSnapshotReader = createGnomeSnapshotReader(
    async (intent, signal) => {
        const { body } = await authenticatedApiCall(
            intent === "existing" ? "/api/v1/gnome/existing" : "/api/v1/gnome",
            ApiGnomeSnapshotResSchema,
            {
                signal,
                cache: "no-store",
                priority: intent === "existing" ? "low" : "auto",
            },
        );
        if (body.status === "OK") return body.gnome;
        if (intent === "existing" && body.code === "GNOME_NOT_FOUND")
            return null;
        throw new GnomeApiError(body.code, body.message);
    },
);
